module.exports = __webpack_public_path__ + "images/arrow_down@2x.png?8723d86d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_down@2x.png
// module id = 595
// module chunks = 7